import type { ClientOngoingLoad } from '@numeo/types-core'
import type { TmsInvoiceRow } from '@numeo/types-main-web-app'
import { formatUsd } from '../../results/format'
import { DocumentCard, placeOf } from './DocumentCard'
import { InlineDocument } from './InlineDocument'

export { placeOf }

interface RateConViewProps {
    row: TmsInvoiceRow
    loadNumber: string
    load: ClientOngoingLoad | undefined
}

/**
 * The rate confirmation as the review drawer shows it (v17 `openDoc`): the document card with the load's reference, origin, destination
 * and agreed rate, where it came from, and the file itself under it. Read only: the rate is changed in the review, never here.
 */
export const RateConView = ({ row, loadNumber, load }: RateConViewProps) => {
    const route = load?.route ?? []
    const rate = load?.originalRate !== undefined && load.originalRate > 0 ? load.originalRate : row.amount_due_usd
    const file = load?.pdfLink ?? null
    return (
        <section className="flex flex-col" aria-label="Rate confirmation">
            <DocumentCard
                title="Rate confirmation"
                customer={row.broker}
                fields={[
                    { label: 'Load reference', value: `#${loadNumber}` },
                    { label: 'Origin', value: placeOf(route[0]) },
                    { label: 'Destination', value: placeOf(route[route.length - 1]) },
                    { label: 'Carrier', value: null },
                    { label: 'Agreed rate', value: typeof rate === 'number' ? formatUsd(rate) : null },
                ]}
                source={file ? 'Connected email · Rate confirmation import' : 'No rate confirmation file is stored for this load.'}
            />
            {file && (
                <div className="mt-4">
                    <InlineDocument url={file} title={`Rate confirmation for load #${loadNumber}`} />
                </div>
            )}
        </section>
    )
}
